<template>
  <div class="card modalFenster" style="z-index: 10000">
    <div class="card-header">
      <img
        src="../../assets/karrusellRestaurant1.jpg"
        class=" "
        style="max-width: 100px"
      />
    </div>

    <div class="row py-2">
      <div class="col-12">
        <img
          :src="adressePic"
          class="rundeEcken"
          style="max-width: 100%; height: auto; display: block; margin: 0 auto"
        />
      </div>
    </div>
    <div class="modal-footer"></div>

    <div class="obenRechts">
      <button class="btn btn-outline-danger" @click="close()">Schließen</button>
    </div>
  </div>
</template>
<script>
import { closeModal } from "jenesius-vue-modal";
export default {
  name: "ModalAushangFSJ",
  props: {
    adressePic: String,
  },
  data() {
    return {
      newSite: null,
    };
  },
  components: {},

  methods: {
    close() {
      closeModal();
    },
  },
  computed: {},
};
</script>
